module.exports = __webpack_public_path__ + "static/Orkney-Regular-d11fee672ecaf231fb0229cb1bbbe348.woff2";